module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"area":"Bereich","capacity":"Kapazität"},"en":{"area":"Area","capacity":"Capacity"},"it":{"area":"Area","capacity":"Capacità"},"lt":{"area":"Plotas","capacity":"Galingumas"},"pl":{"area":"Obszar krajobrazowy","capacity":"Moc"}}')
  delete Component.options._Ctor
}
